import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=0f4ea13d&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=0f4ea13d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4ea13d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f4ea13d')) {
      api.createRecord('0f4ea13d', component.options)
    } else {
      api.reload('0f4ea13d', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=0f4ea13d&scoped=true&", function () {
      api.rerender('0f4ea13d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yo0elvf8uTWF/JS/comp/PopupBox.vue"
export default component.exports